export const SEO_CONTENT = {
  HOME: {
    TITLE: "CanesMeno® Hub | Free Menopause App & Tracker",
    DESCRIPTION:
      "Menopause can be a confusing and overwhelming place. But it doesn’t have to be. The CanesMeno® Hub is here to help you navigate this journey.",
  },
  INTRO: {
    TITLE: "CanesMeno® Hub | Free Menopause App & Tracker",
    DESCRIPTION:
      "Menopause can be a confusing and overwhelming place. But it doesn’t have to be. The CanesMeno® Hub is here to help you navigate this journey.",
  },
  QUIZ: {
    TITLE: "CanesMeno® Hub | Your CanesMeno® Guide",
    DESCRIPTION:
      "It takes around 3-minutes to answer the questions in the CanesMeno® Guide, to learn more about menopause, with downloadable results.",
  },
  TRACKER: {
    TITLE: "Track Your Menopause Signs | CanesMeno",
    DESCRIPTION:
      "Easily track and monitor your menopause experience, from hot flushes and night sweats to mood swings and sleep disturbances.",
  },
  EXPLORE: {
    TITLE: "Explore All Features | CanesMeno",
    DESCRIPTION:
      "Explore all the menopause support we have to offer at CanesMeno, including products, a learning hub and our emotional support coaching program.",
  },
  ABOUT: {
    TITLE: "About Menopause",
    DESCRIPTION:
      "Explore articles about menopause and learn how to equip yourself to navigate this transformative lifestage",
  },
  GET_GUIDANCE: {
    TITLE: "Your Menopause Coach | Menopause Help | CanesMeno",
    DESCRIPTION:
      "We have partnered with Karen Heras-Kelly, a renowned feminine empowerment expert, to provide holistic coaching for your menopause journey.",
  },
  PRODUCTS: {
    TITLE: "Menopause Products | CanesMeno",
    DESCRIPTION:
      "Discover our CanesMeno® product range, designed to address the specific needs of menopausal women, some of the signs and support you on your menopausal journey.",
  },
  PRIVACY: {
    TITLE: "Privacy Statement | CanesMeno",
    DESCRIPTION: "",
  },
  CONDITIONS: {
    TITLE: "Conditions of Use | CanesMeno",
  },
  INSIGHTS: {
    TITLE: "Your Menopause Insights | CanesMeno",
    DESCRIPTION:
      "Track your signs with the CanesMeno menopause Hub to get personal insights and information about your wellbeing.",
  },
  LEARN: {
    TITLE: "Learn About Menopause | CanesMeno",
    DESCRIPTION:
      "Explore articles about menopause and learn how to equip yourself to navigate this transformative lifestage.",
  },
  PROFILE: {
    TITLE: "Profile | CanesMeno",
  },
  NOTIFICATION: {
    TITLE: "Notifications | CanesMeno",
  },
  PROFILE_DETAILS: {
    TITLE: "Profile Details | CanesMeno",
  },
  NOTFOUND: {
    TITLE: "404",
    DESCRIPTION:
      "Sorry, we can't find the page you're looking for. It might have been moved or deleted. Try searching or go back to the homepage.",
  },
  REGISTRATION_STEP_ONETWO: {
    TITLE: "Set Up Your Profile | CanesMeno",
  },
  FAQ: {
    TITLE: "Frequently Asked Questions | CanesMeno",
    DESCRIPTION:
      "Find answers to your questions about the CanesMeno Hub, your trusted companion for navigating menopause. Discover how our app helps track your menopaues experience, provides personalised insights, and offers expert guidance for a confident menopause journey.",
  },
  CONTACT_US: {
    TITLE: "Contact Us | CanesMeno Hub Support",
    DESCRIPTION:
      "Have questions about the CanesMeno® Hub? Contact our friendly team for help with our menopause tracker and app. We’re here to guide and support you on your journey.",
  },
  ABOUT_US: {
    TITLE: "About Us | CanesMeno by Canesten(®)",
    DESCRIPTION:
      "Discover the CanesMeno® Hub, created by the makers of Canesten®, the UK’s No.1 women’s intimate health brand*, supporting you through every stage of menopause.",
  },
  COUNTRY: {
    TITLE: "Choose Your Country | CanesMeno",
    DESCRIPTION:
      "Customise your CanesMeno® Hub by selecting your country, ensuring you get relevant menopause tools and support for your location.",
  },
  SIGNUP_INTRO: {
    TITLE: "CanesMeno®  Hub | Getting Started",
    DESCRIPTION:
      "Welcome to the CanesMeno® Hub! Sign up to get started on your menopause journey.",
  },
  LOGIN_INTRO: {
    TITLE: "CanesMeno®  Hub | Welcome Back",
    DESCRIPTION:
      "Welcome back to the CanesMeno® Hub! Login to continue your menopause journey.",
  },
  SIGNUP: {
    TITLE: "CanesMeno®  Hub | Create your Account",
    DESCRIPTION:
      "Your menopause journey starts here—sign up now to track your signs with the CanesMeno® Hub.",
  },
  LOGIN: {
    TITLE: "CanesMeno®  Hub | Login",
    DESCRIPTION:
      "Log in to your CanesMeno® Hub account to continue your menopause journey with personalised tracking and resources.",
  },
};
